<div class="card d-flex flex-column">
  <div class="header">
    <span class="header-title">{{ expense_action }} {{ expense_type }}</span>
    @if (missing_fields.length) {
      <div class="header-alert d-flex align-items-center" role="alert">
        <i class="fa-solid fa-circle-exclamation me-2"></i>
        <span class="header-alert-prefix">Please fill in:</span>
        <div class="header-alert-chips">
          @for (field of missing_fields; track field) {
            <span class="header-alert-chip">{{ field }}</span>
          }
        </div>
        <button
          type="button"
          class="header-alert-close ms-2"
          aria-label="Dismiss"
          (click)="missing_fields = []"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    }
    <button
      type="button"
      class="close-btn"
      (click)="sharedService.changeRoute('accounting-expense-table')"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <!--body-->
  <div class="scroll">
    <form [formGroup]="this.expenseForm">
      <!-- Top Row-->
      <div class="row d-flex justify-content-between align-items-start">
        <div class="col-auto">
          <div class="form-controls-row">
            <!-- Payee Section -->
            <div class="form-control-group" style="min-width: 350px">
              <label class="bold form-label"
                ><span class="text-danger">*</span>Payee:</label
              >
              <ng-select
                [items]="this.accountingService.vendors"
                bindLabel="contact.display_name"
                bindValue="id"
                [multiple]="false"
                [closeOnSelect]="true"
                class="form-control text-uppercase joined-select"
                style="width: 350px"
                formControlName="payee"
                id="payee"
              >
                <ng-template ng-option-tmp let-item="item">
                  <div
                    [title]="item?.contact?.display_name || ''"
                    class="d-flex align-items-center justify-content-between"
                    style="gap: 30px"
                  >
                    <span class="fw-medium">{{
                      item?.contact?.display_name
                    }}</span>
                    <span
                      style="
                        font-size: 0.85em;
                        color: rgba(255, 255, 255, 0.6);
                        text-align: right;
                      "
                    >
                      {{
                        item?.contact?.phone_number
                          ? formatPhoneNumber(item.contact.phone_number)
                          : ""
                      }}
                      {{
                        item?.contact?.email && item?.contact?.phone_number
                          ? " | "
                          : ""
                      }}
                      {{ item?.contact?.email ? item.contact.email : "" }}
                    </span>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <!-- Button Between Selects -->
            <div class="button-between">
              @if (!this.expenseForm.get("payee").value) {
                <button
                  type="button"
                  class="btn red-btn btn-sm add-button"
                  (click)="addNewPayee()"
                  tooltip="Add Payee"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              }
              @if (this.expenseForm.get("payee").value) {
                <button
                  type="button"
                  class="btn yellow-btn btn-sm edit-button"
                  (click)="editPayee()"
                  tooltip="Edit Payee"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              }
            </div>

            <!-- Payment Account Section -->
            <div class="form-control-group">
              <label class="bold form-label"
                ><span class="text-danger">*</span>Payment Account:</label
              >
              <ng-select
                [items]="
                  sharedService.company_info.accounting_options.payment_accounts
                "
                [multiple]="false"
                [closeOnSelect]="true"
                class="form-control text-uppercase input"
                formControlName="payment_account"
                id="payment_account"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-auto text-end" style="padding-right: 20px">
          <div style="min-width: 100px">
            <div class="form-label mb-1">Total Amount</div>
            <div style="font-weight: 500; font-size: 1.5rem; color: #00a8ff">
              ${{ total }}
            </div>
          </div>
        </div>
      </div>
      <br />
      <!-- Second Row-->
      <div
        class="row d-flex justify-content-between align-items-end"
        style="margin-bottom: 10px"
      >
        <div class="col-auto">
          <!-- Payment Date -->
          <div
            class="form-group2"
            style="display: inline-block; width: 180px; margin-right: 30px"
          >
            <label class="expense-field-label" style="width: 250px"
              ><span class="text-danger">*</span>Payment Date:</label
            >
            <input
              #date_acquired="bsDatepicker"
              type="text"
              class="form-control text-uppercase input"
              formControlName="payment_date"
              id="payment_date"
              style="width: 175px"
              placeholder="__/__/__ __:__"
              [bsConfig]="bsConfig"
              [readOnly]="false"
              bsDatepicker
              autocomplete="off"
            />
            <i
              class="fa-solid fa-calendar icon_inside_input"
              (click)="date_acquired.show()"
              style="cursor: pointer"
            ></i>
          </div>
          <!-- Payment Method -->
          <div
            class="form-group"
            style="display: inline-block; margin-right: 30px"
          >
            <label class="expense-field-label" style="width: 250px"
              ><span class="text-danger">*</span>Payment Method:</label
            >
            <ng-select
              [items]="
                sharedService.company_info.accounting_options.payment_methods
              "
              [multiple]="false"
              [closeOnSelect]="true"
              class="form-control text-uppercase input"
              formControlName="payment_method"
              id="payment_method"
              style="width: 280px"
            ></ng-select>
          </div>
          <!-- Ref # -->
          <div
            class="form-group"
            style="display: inline-block; margin-right: 30px"
          >
            <label class="expense-field-label" style="width: 250px"
              ><span class="text-danger">*</span>Ref #:</label
            >
            <input
              class="form-control"
              type="text"
              id="reference_number"
              formControlName="reference_number"
              style="width: 200px"
              (blur)="verifyDuplicateReference()"
              [class.is-invalid]="
                expenseForm.controls['reference_number'].invalid &&
                expenseForm.controls['reference_number'].touched
              "
              [tooltip]="
                expenseForm.controls['reference_number'].invalid &&
                expenseForm.controls['reference_number'].touched
                  ? expenseForm.controls['reference_number'].hasError(
                      'duplicate'
                    )
                    ? 'This reference number is already being used.'
                    : 'This field is required.'
                  : null
              "
              container="body"
              placement="bottom"
            />
          </div>
          <div class="expense-reference-badge px-3 py-2 mb-2">
            {{ expense_type }} #{{
              this.expenseForm.get("reference_number").value
            }}
          </div>
        </div>

        <div class="col-auto text-end" style="padding-right: 20px">
          <input
            type="file"
            #invoicePicker
            (change)="onInvoiceSelected($event)"
            accept="application/pdf,image/*"
            style="display: none"
          />
          <button
            type="button"
            class="btn blue-btn"
            (click)="invoicePicker.click()"
          >
            <i class="fa-solid fa-file-invoice me-2"></i>Parse Invoice
          </button>
        </div>
      </div>
      <!-- Category and Item Tables-->
      <div
        class="mb-1 p-2 rounded"
        style="
          background: rgba(255, 255, 255, 0.02);
          text-align: left;
          border: 1px solid rgba(255, 255, 255, 0.05);
        "
      >
        <button
          type="button"
          class="btn btn-outline-light btn-sm"
          style="width: 150px; text-align: left; border: none"
          (click)="categoryIsCollapsed = !categoryIsCollapsed"
          [attr.aria-expanded]="!categoryIsCollapsed"
          aria-controls="collapseBasic"
        >
          @if (categoryIsCollapsed) {
            <i class="fa-solid fa-angle-right icon_button_input"></i>
          }
          @if (!categoryIsCollapsed) {
            <i class="fa-solid fa-angle-down icon_button_input"></i>
          }
          Category Details
        </button>
        @if (
          categoryData.length !== 0 &&
          categoryData[0].category !== null &&
          categoryIsCollapsed
        ) {
          <span
            style="
              margin-left: 10px;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.7);
            "
            >Item count: {{ categoryData.length }}</span
          >
        }
        <div id="category" [collapse]="categoryIsCollapsed" [isAnimated]="true">
          <ag-grid-angular
            id="category_list"
            style="width: 100%; margin-top: 10px"
            [theme]="theme"
            [domLayout]="domLayout"
            [columnDefs]="categoryColumnDefs"
            [gridOptions]="categoryGridOptions"
            [rowData]="categoryData"
            [overlayLoadingTemplate]="overlayLoadingTemplate"
            [animateRows]="true"
            [rowSelection]="rowSelection"
            [components]="components"
            [enableBrowserTooltips]="true"
            (cellValueChanged)="onCellValueChangedCategory($event)"
          ></ag-grid-angular>
          <div class="d-flex gap-2 mt-2">
            <button
              type="button"
              class="btn grey-btn btn-sm px-4"
              (click)="addCategoryLineClick()"
              [attr.aria-expanded]="!categoryIsCollapsed"
              aria-controls="collapseBasic"
            >
              <i class="fa-solid fa-plus me-2"></i>Add Lines
            </button>
            <button
              type="button"
              class="btn red-btn btn-sm px-4"
              (click)="clearAllCategoryLinesClick()"
              [attr.aria-expanded]="!categoryIsCollapsed"
              aria-controls="collapseBasic"
            >
              <i class="fa-solid fa-trash-can me-2"></i>Clear all Lines
            </button>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-outline-light btn-sm mt-3"
          style="width: 150px; display: block; text-align: left; border: none"
          (click)="itemIsCollapsed = !itemIsCollapsed"
          [attr.aria-expanded]="!itemIsCollapsed"
          aria-controls="collapseBasic"
        >
          @if (itemIsCollapsed) {
            <i class="fa-solid fa-angle-right icon_button_input"></i>
          }
          @if (!itemIsCollapsed) {
            <i class="fa-solid fa-angle-down icon_button_input"></i>
          }
          Item Details
        </button>
        @if (
          itemData.length !== 0 &&
          itemData[0] !== null &&
          itemData[0]?.product_service !== null &&
          itemIsCollapsed
        ) {
          <span
            style="
              margin-left: 10px;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.7);
            "
            >Item count: {{ itemData.length }}</span
          >
        }
        <div
          id="product_service"
          [collapse]="itemIsCollapsed"
          [isAnimated]="true"
        >
          <div
            class="mb-1 p-2 rounded"
            style="
              background: rgba(255, 255, 255, 0.02);
              text-align: left;
              border: 1px solid rgba(255, 255, 255, 0.05);
            "
          >
            <ag-grid-angular
              id="product_service_list"
              style="width: 100%"
              [theme]="theme"
              [domLayout]="domLayout"
              [columnDefs]="itemsColumnDefs"
              [gridOptions]="itemsGridOptions"
              [rowData]="itemData"
              [overlayLoadingTemplate]="overlayLoadingTemplate"
              [animateRows]="true"
              [rowSelection]="rowSelection"
              [components]="components"
              [enableBrowserTooltips]="true"
              (cellValueChanged)="onCellValueChangedItems($event)"
            ></ag-grid-angular>
            <div class="d-flex gap-2 mt-2">
              <button
                type="button"
                class="btn grey-btn btn-sm px-4"
                (click)="addItemLineClick()"
                [attr.aria-expanded]="!categoryIsCollapsed"
                aria-controls="collapseBasic"
              >
                <i class="fa-solid fa-plus me-2"></i>Add Lines
              </button>
              <button
                type="button"
                class="btn red-btn btn-sm px-4"
                (click)="clearAllItemLinesClick()"
                [attr.aria-expanded]="!categoryIsCollapsed"
                aria-controls="collapseBasic"
              >
                <i class="fa-solid fa-trash-can me-2"></i>Clear all Lines
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Memo, Attachments and Total -->
      <div class="row align-items-start mt-4">
        <!-- Memo -->
        <div class="col-4">
          <label class="form-label">Memo:</label>
          <textarea
            class="form-control"
            type="text"
            id="memo"
            formControlName="memo"
            rows="4"
            style="height: 120px; resize: none"
            placeholder="Enter memo here... Max 255 chars"
            maxlength="255"
          ></textarea>
          <small
            [class.text-danger]="expenseForm.get('memo').value?.length >= 255"
            class="text-muted d-block text-end"
            >{{ expenseForm.get("memo").value?.length || 0 }} / 255</small
          >
        </div>

        <!-- Attachments -->
        <div class="col-5">
          <label class="form-label">Attachments:</label>
          <ngx-dropzone
            (change)="addAttachment($event)"
            [maxFileSize]="sharedService.file_size_limit"
            [multiple]="true"
            accept=".pdf"
          >
            <ngx-dropzone-label>
              <i
                class="fa-solid fa-cloud-arrow-up fs-2 mb-2"
                style="color: #00a8ff"
              ></i>
              <br />
              <span style="color: #00a8ff; font-weight: 500"
                >Add Attachments</span
              >
              <br />
              <span style="font-size: small; opacity: 0.6"
                >Max file size 20MB</span
              >
            </ngx-dropzone-label>

            @for (file of attachments; track file) {
              <ngx-dropzone-preview
                [removable]="true"
                (removed)="removeAttachment(file)"
              >
                <ngx-dropzone-label>{{ file.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
            }
          </ngx-dropzone>
        </div>

        <!-- Total box -->
        <div class="col-3">
          <div
            class="p-4 rounded"
            style="
              background: rgba(0, 0, 0, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.05);
              margin-top: 25px;
            "
          >
            <!-- Total -->
            <div
              class="div d-flex justify-content-between py-2"
              style="font-size: 1.25rem"
            >
              <span style="color: #ffffff; font-weight: 500">Total:</span>
              <span style="color: #00a8ff; font-weight: 500"
                >${{ total.toFixed(2) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- footer buttons -->
  <div class="footer">
    <button
      type="button"
      class="btn grey-btn px-4"
      (click)="sharedService.changeRoute('accounting-expense-table')"
    >
      Cancel
    </button>

    <div class="d-flex gap-3">
      @if (this.expense_action === "Edit") {
        <button class="btn red-btn px-4" (click)="deleteExpenseClick()">
          <i class="fa-solid fa-trash me-2"></i>Delete Expense
        </button>
      }

      <button
        type="button"
        class="btn green-btn px-4"
        [class.disabled]="
          !this.expenseForm.valid ||
          (!is_category_item && !is_product_service_item)
        "
        (click)="attemptSave(false)"
      >
        Save
      </button>

      <button
        type="button"
        class="btn green-btn px-5"
        [class.disabled]="
          !this.expenseForm.valid ||
          (!is_category_item && !is_product_service_item)
        "
        (click)="attemptSave(true)"
      >
        Save and Close
      </button>
    </div>
  </div>
</div>
